module.exports = __webpack_public_path__ + "d431b9b730240a3645a5f51aac42f056.png";